// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l9eYPbBMMwTTE49rufoh {
  display: flex;
  width: fit-content;
  height: fit-content;
  align-items: center;
  gap: 0.5rem;
}
.l9eYPbBMMwTTE49rufoh.IvXWvNZ9nFvVMegP2shh {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/componentes/HelperText/HelperText.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACI,mBAAA;AAER","sourcesContent":[".container{\r\n    display: flex;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    &.desabilitado{\r\n        cursor: not-allowed;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `l9eYPbBMMwTTE49rufoh`;
export var desabilitado = `IvXWvNZ9nFvVMegP2shh`;
export default ___CSS_LOADER_EXPORT___;
